<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>批量代付</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS1118</td></tr>
          <tr><td>批量订单号</td><td>outOrderId</td><td>String（32）</td><td>是</td><td>测试：唯一就行</td></tr>
          <tr><td>商户号</td><td>mchtCd</td><td>String (15)</td><td>是</td><td>测试：MCHT100005803</td></tr>
          <tr><td>产品</td><td>proCd</td><td>String (15)</td><td>是</td><td>默认：agent</td></tr>
          <tr><td>列表</td><td>itemsList</td><td></td><td>是</td><td></td></tr>
          <tr><td>出款订单号</td><td>item1</td><td>String(32) </td><td>是</td><td>200808180010001</td></tr>
          <tr><td>收款方银行账户名称</td><td>item2</td><td>String(64)</td><td>是</td><td>张三</td></tr>
          <tr><td>收款方身份证号</td><td>item3</td><td>String(32)</td><td>否</td><td>360xxxxxx</td></tr>
          <tr><td>收款方银行账号</td><td>item4</td><td>String(32)</td><td>是</td><td>61xxxxxxx</td></tr>
          <tr><td>收款方开户银行</td><td>item5</td><td>String(32)</td><td>是</td><td>工商银行</td></tr>
          <tr><td>银行代码</td><td>item6</td><td>String(20)</td><td>是</td><td>BOC</td></tr>
          <tr><td>省份</td><td>item7</td><td>String(32)</td><td>是</td><td>浙江省</td></tr>
          <tr><td>城市</td><td>item8</td><td>String(32)</td><td>是</td><td>杭州市</td></tr>
          <tr><td>支行名称</td><td>item9</td><td>String(64)</td><td>是</td><td>中国农业银行深圳南山支行</td></tr>
          <tr><td>金额</td><td>item10</td><td>Number(15,2)</td><td>是</td><td>10.00</td></tr>
          <tr><td>银行卡属性</td><td>item11</td><td>String(12)</td><td>是</td><td>1-对私,2-对公</td></tr>
          <tr><td>银行卡类型</td><td>item12</td><td>String(12)</td><td>是</td><td>1-借,2-贷</td></tr>
          <tr><td>摘要</td><td>item13</td><td>String(64)</td><td>否</td><td>备注</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>测试秘钥：S5DH89W2W37E4CF6KJSH23SK</p>
        <p>订单支付(100.30元)，请求报文：</p>
        <code>{
        "keyField":"MCHT100005803",
        "typeField":"MCHT",
        "dataField": " BSWchrZ27k9eumaxc/TU6Z2lF9hrh3V0ZPKEKy76Qr205YaSC+SdjuviLBB9csVqdt7YszPHtUCxpH1F9FCI6kBvDiHhpNROEa01xxmz3q0umNd7RX5OFxw6ncPIJPhhaHFIwNdLV2Yn9DkTgR6sGhhAzbD03QiZt/lQrT5c5lsKAqyfHUJfvwgfpakH0sDMlLy02x33OogotYwQurcPYZx1freyHgogOnaIe9EDnIEotYwQurcPYY/6k9KCHebJRqphZNq/X4c5TwzIIG94sjqFld4pMevsKLWMELq3D2EotYwQurcPYTpgwKgycqMk2OH7INhfAdm05YaSC+Sdjii1jBC6tw9hxIgoh8e+ca0IawUbuMOExJHMAlTj8EWv+uvCBOcuVbC05YaSC+Sdjii1jBC6tw9hxIgoh8e+ca07mGKE+yCxD0Tsu3k9pm3jmCEoZfqYmr0otYwQurcPYSi1jBC6tw9hHYViv9EL8I1WTpq8SJCXBicGyLzIMo80QOb1rPw7c+MotYwQurcPYSi1jBC6tw9hQS9b+tUXi8dqFK+sktvyfbTlhpIL5J2OKLWMELq3D2HEiCiHx75xrf055ZCrnv3bHATe3QtCAEw6doh70QOcgSi1jBC6tw9hj/qT0oId5smCkDLgo21zv5z9d1owma+7KLWMELq3D2EotYwQurcPYRUrM2dGzneHVk6avEiQlwYnBsi8yDKPNOyHEY73rRvdtI0CK0bCVZv+EWLwtLYdqCi1jBC6tw9hKLWMELq3D2HenqAmE1YvDv6wcFybpZQ/OnaIe9EDnIEotYwQurcPYY/6k9KCHebJisP2oKKgLjU6doh70QOcgSi1jBC6tw9hj/qT0oId5snISoemjAve0Dp2iHvRA5yBKLWMELq3D2GP+pPSgh3myRmL1FI4hPNhKLWMELq3D2EotYwQurcPYc2KAEcpaLIYKLWMELq3D2FUd8vabZwbhyi1jBC6tw9hKLWMELq3D2HySiFnWFzvJhmg02C1CD9hqpuY8faG/Hzo9FI/gzGRXyi1jBC6tw9h/Tlm5l4vVk4CvddVsejD1r93K27ruyjpKLWMELq3D2EotYwQurcPYWj8ZakUZgm4XmXSmdCWR1Wz9NH8N79GK3XT5cpHQZVWKLWMELq3D2EotYwQurcPYak3WaMe7ij57d6yt6W7zVoOGkyFTUcbAhfCRfU/VjntKLWMELq3D2EotYwQurcPYZhatuA6jpv/Q82EVs8ywKxn0diMVN2WDXinQc+oIQWPKLWMELq3D2EotYwQurcPYR7Skawf5MNUi3BMQhOVGLUotYwQurcPYSi1jBC6tw9hSI4FBuYrCPHQCFr92wF9MhpNAo+pLwHDKLWMELq3D2EotYwQurcPYf4ElSTdkwA5d+W16dJiWhNT9iSSSLjatyi1jBC6tw9hKLWMELq3D2G881nNLqu7Y0PNhFbPMsCsZ9HYjFTdlg3Ve2R82Ewt68qUnhQipGygbD7gjmuI61MotYwQurcPYQoCrJ8dQl+/ecjJ/tGy5hZxLqakehVYZCi1jBC6tw9hKLWMELq3D2F18x3mth/Cx4It+nd02bhgKLWMELq3D2EotYwQurcPYXId48ZCmSR9gi36d3TZuGAotYwQurcPYSi1jBC6tw9h68apQtMlLxKzGnJ4Nrd5Jyi1jBC6tw9hOnTpy/3/IC46doh70QOcgbxPy5V0bRij"
          }</code>
        <p>dataField解密后：</p>
        <code>{
        "trscode":"TRANS1118",
        "outOrderId":"8415000545",
        "proCd":"agent",
        "mchtCd":"MCHT100005803",
        "itemsList":[
        {
        "item1":"854521541100103",
        "item2":"李四",
        "item3":"430482192805180075",
        "item4":"6225211008709429",
        "item5":"浦东发展银行",
        "item6":"SPDB",
        "item7":"广东省",
        "item8":"广州市",
        "item9":"浦东发展银行体育西支行",
        "item10":"100",
        "item11":"1",
        "item12":"1",
        "item13":""
        },
        {
        "item1":"854521541100104",
        "item2":"张三",
        "item3":"430482192805180076",
        "item4":"6225211008709400",
        "item5":"浦东发展银行",
        "item6":"SPDB",
        "item7":"广东省",
        "item8":"广州市",
        "item9":"浦东发展银行体育西支行",
        "item10":"101",
        "item11":"1",
        "item12":"1",
        "item13":""
        }
        ]
          }</code>
        <h4 class="common-margin-top">应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（10）</td><td>是</td><td>成功：0000 失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（100）</td><td>是</td><td></td></tr>
          <tr><td>平台流水号</td><td>orderCd</td><td>String(20)</td><td>是</td><td>平台返回的交易流水号</td></tr>
          <tr><td>外部订单号</td><td>outOrderId</td><td>String（32）</td><td>是</td><td>下游上送的交易流水号</td></tr>
          <tr><td>交易状态</td><td>transStatus</td><td>String（10）</td><td>否</td><td>100-支付成功（支付订单）或退款成功（退款订单）
            101-待支付
            102-支付失败（支付订单）或退款失败（退款订单）
            103-订单处理中
            104-已撤销
          </td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Pldf',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [{'url': '/interface/kj', 'name': '快捷支付'},
        {'url': '/interface/tk', 'name': '退款'},
        {'url': '/interface/cx', 'name': '交易查询'},
        {'url': '/interface/pldf', 'name': '批量代付'},
        {'url': '/interface/ybtz', 'name': '异步通知'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Pldf.vue